import * as yup from 'yup';

export const client_Credentials_schema = {
  username: '',
  email: '',
  password: '',
  confirmPassword: '',
};

export const client_Credentials_validation_schema = yup.object().shape({
  username: yup.string().required('username_is_required'),
  password: yup.string().required('password_is_required'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'passwords_must_match')
    .required('confirm_Password_is_required'),
});

